<pm-modal class="pm-ch" title="Add Client from Companies House"
  subtitle="Search by company name or registration number to auto-fill client details."
  size="lg" [busy]="anyApplying" (closed)="closed.emit()">

  <span pmModalIcon class="pm-modal-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
      stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
      <rect x="5" y="3" width="14" height="18" rx="2"/>
      <path d="M9 7h6M9 11h6M9 15h4"/>
    </svg>
  </span>

  <div class="pm-ff">
    <span class="pm-ff__label">Company Name or Registration Number</span>
    <div class="pm-ch__search">
      <input class="pm-ff__input" placeholder="e.g. Acme Ltd or 01234567" autocomplete="off"
        [value]="query" [disabled]="anyApplying"
        (input)="onQueryInput($event)" (keydown)="onQueryKeydown($event)">
      <button type="button" class="pm-ch__search-btn" [disabled]="!canSearch" (click)="runSearch()">
        @if (searching) {
        <svg class="pm-ch__spinner" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.3" stroke-width="3"/>
          <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        </svg>
        Searching…
        } @else {
        Search
        }
      </button>
    </div>
    <span class="pm-ff__hint">Press Enter to search. Results come straight from the Companies House register.</span>
  </div>

  @if (error) {
  <p class="pm-ch__error" role="alert">{{ error }}</p>
  }

  @if (results.length > 0) {
  <div class="pm-ch__table-wrap">
    <table class="pm-ch__table">
      <thead>
        <tr>
          <th scope="col">Company</th>
          <th scope="col">Registration No</th>
          <th scope="col">Incorporated</th>
          <th scope="col">Registered Address</th>
          <th scope="col"><span class="pm-ch__sr">Action</span></th>
        </tr>
      </thead>
      <tbody>
        @for (item of results; track item.companyNumber) {
        <tr>
          <td class="pm-ch__td-company">
            <span class="pm-ch__result-name">{{ displayName(item.companyName) }}</span>
            @if (item.companyStatus) {
            <span class="pm-ch__status" [attr.data-tone]="statusTone(item.companyStatus)">{{ item.companyStatus }}</span>
            }
          </td>
          <td class="pm-ch__td-no">{{ item.companyNumber }}</td>
          <td class="pm-ch__td-inc">{{ item.dateOfCreation || '—' }}</td>
          <td class="pm-ch__td-addr" [title]="item.addressSnippet || ''">{{ item.addressSnippet || '—' }}</td>
          <td class="pm-ch__td-use">
            <button type="button" class="pm-ch__use" [disabled]="anyApplying" (click)="use.emit(item)">
              @if (isApplying(item)) {
              <svg class="pm-ch__spinner" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.3" stroke-width="3"/>
                <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
              </svg>
              Applying…
              } @else {
              Use
              }
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @else if (searched && !searching && !error) {
  <!-- Only after a search has actually run: an empty list on open is not "no matches". -->
  <p class="pm-ch__empty">No companies match that name or number.</p>
  }
</pm-modal>
